import React, { useContext, useState } from "react";
import { LoanSummary } from "../LoanSummary/LoanSummary";
import { LenderSelection } from "./components/LenderSelection";
import { areAllLoanApplicationsProcessed } from "../shared/utils/areAllApplicationsProcessed";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { CustomTheme } from "@nemuru-eng/js-api-client";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { FullScreenLoading } from "./_shared/components/FullScreenLoading";

export const BORROWER_SELECTION_STEP_NAMES = {
  LOAN_SUMMARY: "LOAN_SUMMARY",
  LENDER_SELECTION: "LENDER_SELECTION",
};

export const BorrowerSelectionLoanSummary = ({ ...props }) => {
  const {
    state: { loanApplications, checkoutSession },
  } = useContext(ProcessContext);

  const {
    state: { themeName },
  } = useContext(ConfigContext);

  const [lenderSelectionStep, setLenderSelectionStep] = useState(
    areAllLoanApplicationsProcessed(loanApplications)
      ? BORROWER_SELECTION_STEP_NAMES.LENDER_SELECTION
      : BORROWER_SELECTION_STEP_NAMES.LOAN_SUMMARY
  );

  if (themeName === CustomTheme.KTUIN && !checkoutSession) {
    return <FullScreenLoading />;
  }

  return (
    <>
      {lenderSelectionStep === BORROWER_SELECTION_STEP_NAMES.LOAN_SUMMARY && (
        <LoanSummary
          {...props}
          setLenderSelectionStep={setLenderSelectionStep}
        />
      )}
      {lenderSelectionStep ===
        BORROWER_SELECTION_STEP_NAMES.LENDER_SELECTION && (
        <LenderSelection {...props} />
      )}
    </>
  );
};
